import {styled} from '@mui/material/styles'
import AppBar from '@mui/material/AppBar'

const PREFIX = 'AdminPanelHeader'

const classes = {
  logo: `${PREFIX}-logo`
}

const Root = styled('div')(({theme}) => ({
  [`& .${classes.logo}`]: {
    [theme.breakpoints.only('lg')]: {
      maxWidth: '100%'
    },
    height: 5,
    maxHeight: 2,
    maxWidth: 135
  }
}))

const StyledAppBar = styled(AppBar)(({theme}) => ({
  background: theme.palette.hpWhite,
  height: '40px'
}))

const StyledDiv = styled('div')(() => ({
  paddingLeft: '5px',
  paddingRight: '5px'
}))

const StyledDivLogo = styled(StyledDiv)(() => ({
  paddingTop: '8px'
}))

export {classes, StyledDiv, StyledDivLogo, StyledAppBar, Root}
